<template>
    <div class="container mescroll-touch">
        <img src="../../assets/images/zuzhitop.png" class="img" />
        <img src="../../assets/images/zuzhititle1.png" class="zuzhititleimg" />
        <!-- <img src="../../assets/images/topguanggao.png" class="guanggaoimg" /> -->
        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">大会名誉主席</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">廖万清</div>
                <div class="name">张建中</div>
                <div class="name">高兴华</div>
                <div class="name">张福仁</div>
                <div class="name">陈&nbsp;&nbsp;&nbsp;&nbsp;翔</div>
                <div class="name">王&nbsp;&nbsp;&nbsp;&nbsp;刚</div>
                <div class="name">郑志忠</div>
            </div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">大会主席</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">吴文育</div>
            </div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">大会执行主席</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">陈爱军</div>
            </div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">大会副主席</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">李福伦</div>
                <div class="name">李&nbsp;&nbsp;&nbsp;&nbsp;航</div>
                <div class="name">李&nbsp;&nbsp;&nbsp;&nbsp;吉</div>
                <div class="name">刘&nbsp;&nbsp;&nbsp;&nbsp;红</div>
                <div class="name">满孝勇</div>
                <div class="name">潘&nbsp;&nbsp;&nbsp;&nbsp;萌</div>
            </div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">大会秘书长</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">杜&nbsp;&nbsp;&nbsp;&nbsp;娟</div>
            </div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">大会发言人</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">樊一斌</div>
            </div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">秘书处</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">李&nbsp;&nbsp;&nbsp;&nbsp;勇</div>
                <div class="name">宁晓明</div>
                <div class="name">齐&nbsp;&nbsp;&nbsp;&nbsp;盼</div>
                <div class="name">张&nbsp;&nbsp;&nbsp;&nbsp;岷</div>
                <div class="name">陈伟文</div>
            </div>
        </div>

        <img src="../../assets/images/zuzhititle2.png" class="zuzhititleimg1" />
        <!-- <img src="../../assets/images/topguanggao.png" class="guanggaoimg" /> -->
        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">主&nbsp;&nbsp;&nbsp;&nbsp;席</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">史玉玲</div>
            </div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">委&nbsp;&nbsp;&nbsp;&nbsp;员</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">李&nbsp;&nbsp;&nbsp;&nbsp;航</div>
                <div class="name">李&nbsp;&nbsp;&nbsp;&nbsp;巍</div>
                <div class="name">林尽染</div>
                <div class="name">卢&nbsp;&nbsp;&nbsp;&nbsp;忠</div>
                <div class="name">马彦云</div>
                <div class="name">满孝勇</div>
                <div class="name">宋志强</div>
                <div class="name">项蕾红</div>
                <div class="name">于&nbsp;&nbsp;&nbsp;&nbsp;波</div>
                <div class="name">张成锋</div>
                <div class="name">樊一斌</div>
            </div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">学术秘书组</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">杜&nbsp;&nbsp;&nbsp;&nbsp;娟</div>
                <div class="name">于&nbsp;&nbsp;&nbsp;&nbsp;倩</div>
            </div>
        </div>

        <img src="../../assets/images/zuzhititle3.png" class="zuzhititleimg1" />
        <!-- <img src="../../assets/images/topguanggao.png" class="guanggaoimg" /> -->
        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">主&nbsp;&nbsp;&nbsp;&nbsp;席</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">吴文育</div>
            </div>
        </div>

        <div class="model1">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">委&nbsp;&nbsp;&nbsp;&nbsp;员</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">卜璋于</div>
                <div class="name">蔡&nbsp;&nbsp;&nbsp;&nbsp;涛</div>
                <div class="name">曹&nbsp;&nbsp;&nbsp;&nbsp;华</div>
                <div class="name">常&nbsp;&nbsp;&nbsp;&nbsp;江</div>
                <div class="name">陈爱军</div>
                <div class="name">陈菊萍</div>
                <div class="name">陈柳青</div>
                <div class="name">陈晓栋</div>
                <div class="name">党宁宁</div>
                <div class="name">邓&nbsp;&nbsp;&nbsp;&nbsp;辉</div>
                <div class="name">邓智利</div>
                <div class="name">杜&nbsp;&nbsp;&nbsp;&nbsp;娟</div>
                <div class="name">段彦娟</div>
                <div class="name">樊一斌</div>
                <div class="name">傅&nbsp;&nbsp;&nbsp;&nbsp;强</div>
                <div class="name">葛新红</div>
                <div class="name">耿松梅</div>
                <div class="name">顾&nbsp;&nbsp;&nbsp;&nbsp;煜</div>
                <div class="name">纪&nbsp;&nbsp;&nbsp;&nbsp;超</div>
                <div class="name">鞠&nbsp;&nbsp;&nbsp;&nbsp;强</div>
                <div class="name">李福伦</div>
                <div class="name">李&nbsp;&nbsp;&nbsp;&nbsp;航</div>
                <div class="name">李&nbsp;&nbsp;&nbsp;&nbsp;吉</div>
                <div class="name">李建伟</div>
                <div class="name">李&nbsp;&nbsp;&nbsp;&nbsp;明</div>
                <div class="name">李&nbsp;&nbsp;&nbsp;&nbsp;巍</div>
                <div class="name">李艳玲</div>
                <div class="name">李玉叶</div>
                <div class="name">李智铭</div>
                <div class="name">梁云生</div>
                <div class="name">林尽染</div>
                <div class="name">刘&nbsp;&nbsp;&nbsp;&nbsp;红</div>
                <div class="name">刘业强</div>
                <div class="name">卢&nbsp;&nbsp;&nbsp;&nbsp;忠</div>
                <div class="name">鲁&nbsp;&nbsp;&nbsp;&nbsp;严</div>
                <div class="name">罗晓燕</div>
                <div class="name">骆肖群</div>
                <div class="name">吕成志</div>
                <div class="name">马彦云</div>
                <div class="name">满孝勇</div>
                <div class="name">潘&nbsp;&nbsp;&nbsp;&nbsp;萌</div>
                <div class="name">潘炜华</div>
                <div class="name">皮龙泉</div>
                <div class="name">乔建军</div>
                <div class="name">宋秀祖</div>
                <div class="name">宋志强</div>
                <div class="name">粟&nbsp;&nbsp;&nbsp;&nbsp;娟</div>
                <div class="name">孙&nbsp;&nbsp;&nbsp;&nbsp;澜</div>
                <div class="name">陶&nbsp;&nbsp;&nbsp;&nbsp;娟</div>
                <div class="name">陶茂灿</div>
                <div class="name">汪&nbsp;&nbsp;&nbsp;&nbsp;旸</div>
                <div class="name">汪&nbsp;&nbsp;&nbsp;&nbsp;宇</div>
                <div class="name">王&nbsp;&nbsp;&nbsp;&nbsp;芳</div>
                <div class="name">王惠平</div>
                <div class="name">王再兴</div>
                <div class="name">魏爱华</div>
                <div class="name">吴海竞</div>
                <div class="name">伍洲炜</div>
                <div class="name">项蕾红</div>
                <div class="name">徐&nbsp;&nbsp;&nbsp;&nbsp;楠</div>
                <div class="name">徐学刚</div>
                <div class="name">许素玲</div>
                <div class="name">杨&nbsp;&nbsp;&nbsp;&nbsp;骥</div>
                <div class="name">杨镓宁</div>
                <div class="name">尹光文</div>
                <div class="name">尹志强</div>
                <div class="name">于&nbsp;&nbsp;&nbsp;&nbsp;波</div>
                <div class="name">喻&nbsp;&nbsp;&nbsp;&nbsp;楠</div>
                <div class="name">张成锋</div>
                <div class="name">张春红</div>
                <div class="name">张慧萍</div>
                <div class="name">张&nbsp;&nbsp;&nbsp;&nbsp;岷</div>
                <div class="name">张&nbsp;&nbsp;&nbsp;&nbsp;勇</div>
                <div class="name">赵恒光</div>
                <!-- <div class="name">郑淑云</div> -->
                <div class="name">周&nbsp;&nbsp;&nbsp;&nbsp;城</div>
                <div class="name">周乃慧</div>
                <div class="name">周&nbsp;&nbsp;&nbsp;&nbsp;强</div>
                <div class="name">周&nbsp;&nbsp;&nbsp;&nbsp;汛</div>
                <div class="name">朱&nbsp;&nbsp;&nbsp;&nbsp;敏</div>
                <div class="name">左先波</div>
            </div>
        </div>

        <div class="footer">
            按姓氏拼音排序
        </div>
        <floatback />
    </div>
</template>

<script>
import floatback from './floatback.vue';
import mixin from '../../common/mixin/mixins'
export default {
    name: 'zuzhi',
    data() {
        return {
        }
    },
    mixins: [mixin],
    components: {
        floatback
    },
    created() {
        this.initacmedShare();
        document.title = "ACMED第一届学术年会";
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.container {
    height: 100%;
    width: 100%;
    // background: rgb(228, 236, 255);
}

.img {
    display: block;
    width: 100%;
    margin-bottom: .2rem
}

.zuzhititleimg {
    display: block;
    width: 55%;
    margin: auto;
    margin-bottom: .2rem
}

.zuzhititleimg1 {
    display: block;
    width: 55%;
    margin: .5rem auto .2rem auto;
}

.guanggaoimg {
    display: block;
    width: 92%;
    margin: 0.5rem auto;
}

.modelline {
    border-bottom: 1px solid rgb(0, 53, 133);
    border-bottom-left-radius: 50rem;
}

.modeltitle {
    background: rgb(0, 53, 133);
    width: 37%;
    display: flex;
    flex-direction: row;
    padding: 0.1rem;
    border-radius: 30px 50px 0px 30px;
}

.modeltitleimg {
    display: block;
    width: 15%;
    background: #fff;
    border-radius: 50rem;
    width: 0.5rem;
    height: 0.5rem;
    box-sizing: border-box;
    padding: 0.05rem;
}

.modeltitletext {
    margin-left: 0.2rem;
    color: #fff;
    font-weight: bold;
    // font-size: 16px;
}

.model {
    width: 92%;
    margin: auto;
    margin-top: 0.5rem;
}

.model1 {
    width: 92%;
    margin: auto;
    margin-top: 0.5rem;
    padding-bottom: .3rem;
}

.center {
    text-align: center;
}

.preple {
    color: rgb(0, 53, 133);
}

.neirong {
    margin-top: .3rem
}

.ziti {
    font-size: .37rem;
}

.neirong {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.name {
    width: 14.28%;
    text-align: center;
    font-size: .35rem;
    margin: 0.1rem 0;
}

.footer {
    width: 92%;
    margin: auto;
    margin-bottom: 0.5rem;
    text-align: right;
    font-size: .3rem;
    border-bottom: 0.5rem solid rgb(0, 53, 133);
    font-weight: bold;
}
</style>